import React from 'react';

import BrowseLayer from 'topmeteo/base-image/components/BrowseLayerOuter/BrowseLayer';
import SwitchProduct from 'topmeteo/base-image/components/SwitchProduct';
import SwitchDate from 'topmeteo/base-image/components/SwitchDate';
import SwitchIndex from 'topmeteo/base-image/components/SwitchIndex';

const BrowseLayerOuter = () => (
    <div className="browse-layer-outer">
        <BrowseLayer>
            <SwitchProduct />
        </BrowseLayer>
        <BrowseLayer>
            <SwitchDate />
        </BrowseLayer>
        <BrowseLayer>
            <SwitchIndex />
        </BrowseLayer>
    </div>
);

export default BrowseLayerOuter;
